import { render } from "./ImageSection.vue?vue&type=template&id=1779b155"
import script from "./ImageSection.vue?vue&type=script&lang=js"
export * from "./ImageSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.12_webpack@5.96.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__